module.exports = __webpack_public_path__ + "img/situation.5ee9a766.png";